import { ConcreteTestSet } from '../../../../ConcreteTestSetTrackerContext/types'
import RelationTable from '../RelationTable'
import { useColumns } from './hooks/useColumns'
import { useExpand } from './hooks/useExpand'

const Cores: React.FC<ConcreteTestSet> = ({ concretePlacements }) => {
  const columns = useColumns()
  const expand = useExpand()
  return (
    <RelationTable
      records={concretePlacements.flatMap(
        ({ placementId, concreteCoreMeasurements }) =>
          concreteCoreMeasurements.map((core) => ({ placementId, ...core }))
      )}
      rowKey="globalId"
      columns={columns}
      expand={expand}
    />
  )
}

export default Cores
